/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/canvaseditor/shapes/Shape',['../../lib/@waca/core-client/js/core-client/ui/core/Class', '../DefaultAttributes'], function (Class, DefaultAttributes) {
	'use strict';

	var Shape = Class.extend({

		shape: null,
		originalX: null,
		originalY: null,
		defaultWidth: 0.1,
		defaultHeight: 0.1,
		defaultAttributes: DefaultAttributes,

		/**
   * Called by constructor.
   * @param options {Object} Options
   */
		init: function init(options) {
			// eslint-disable-line no-unused-vars
			Shape.inherited('init', this, arguments);
		},

		getShape: function getShape() {
			return this.shape;
		},

		resize: function resize(xCoord, yCoord) {}, // eslint-disable-line no-unused-vars

		finish: function finish(event, canvas) {}, // eslint-disable-line no-unused-vars

		createPath: function createPath(pen) {} // eslint-disable-line no-unused-vars

	});

	return Shape;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

